/* global BigInt */
// Presentation only: effective engine totals never replace local source inputs.
const { parse, format } = require('./b1/decimal');
const product = (a, b) => {
  const x = parse(a), y = parse(b);
  return x && y ? { coefficient: x.coefficient * y.coefficient, scale: x.scale + y.scale } : null;
};
export const localQuantity = line => line.localQuantity ?? line.quantity;
// Display a certified effective amount per occurrence of the parent. Never
// write this rounded display value back into the source or engine totals.
export const localLineAmount = (value, node, digits = 2) => {
  if (!node) return null;
  const amount = parse(value, { signed: true });
  const multiplier = parse(node?.parentLineId == null ? '1' : node.ancestorMultiplier);
  if (!amount || !multiplier || multiplier.coefficient === 0n) return null;
  const numerator = amount.coefficient * 10n ** BigInt(multiplier.scale + digits);
  const denominator = multiplier.coefficient * 10n ** BigInt(amount.scale);
  const magnitude = numerator < 0n ? -numerator : numerator;
  const rounded = (magnitude + denominator / 2n) / denominator;
  return format({ coefficient: numerator < 0n ? -rounded : rounded, scale: digits });
};
export const localLaborHours = line => {
  const hours = line.laborItems?.length ? line.laborItems.map(item => product(item.resourceQuantity, item.unitHours))
    : [product(line.estimatedHours ?? '0', localQuantity(line))];
  if (hours.some(value => !value)) return null;
  const scale = Math.max(0, ...hours.map(value => value.scale));
  return format({ scale, coefficient: hours.reduce((sum, value) => sum + value.coefficient * 10n ** BigInt(scale - value.scale), 0n) });
};
